function User_form_profile(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    checkboxPassword: '.js-checkbox-password',
	    containerPassword: '.js-container-password',
	    fieldPasswordCurrent: '.js-field-password-current',
	    fieldPasswordNew: '.js-field-password-new',
	    fieldPasswordConfirm: '.js-field-password-confirm'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded'
    };

    this.classNames = {
	    disabled: 'disabled'
    };

    this.init = function() {

    	this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$checkboxPassword = this.$element.find(this.selectors.checkboxPassword);

	    if (this.$checkboxPassword.length) {
		    this.$containerPassword = this.$element.find(this.selectors.containerPassword);
		    this.$fieldPasswordCurrent = this.$element.find(this.selectors.fieldPasswordCurrent);
		    this.$fieldPasswordNew = this.$element.find(this.selectors.fieldPasswordNew);
		    this.$fieldPasswordConfirm = this.$element.find(this.selectors.fieldPasswordConfirm);

			this.$checkboxPassword.on('i4:change', this.$onChangeCheckboxPassword.bind(this));

			this.$formParent.on(this.triggers.afterLoaded, (function() {
				this.$onChangeCheckboxPassword();
			}).bind(this));
		}
    };

    this.$onChangeCheckboxPassword = function() {
    	if (this.$checkboxPassword.is(':checked')) {

			this.$containerPassword.show();

			this.$fieldPasswordCurrent.toggleClass(this.classNames.disabled, false);
			this.$fieldPasswordNew.toggleClass(this.classNames.disabled, false);
			this.$fieldPasswordConfirm.toggleClass(this.classNames.disabled, false);
		} else {

			this.$containerPassword.hide();

			this.$fieldPasswordCurrent.toggleClass(this.classNames.disabled, true);
			this.$fieldPasswordNew.toggleClass(this.classNames.disabled, true);
			this.$fieldPasswordConfirm.toggleClass(this.classNames.disabled, true);
		}

    };
}
